import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { Dashboard } from "./views/Dashboard";
import { LoginView } from "./views/LoginView";
import { AuthProvider, useAuth } from "./hooks/useAuth"; // Keep useAuth for LoginRedirect
import { SocketProvider, useSocket } from "./components/SocketProvider";
import { useDashboardData } from "./hooks/useDashboardData";
import { FullScreenLoader } from "./components/FullScreenLoader";
import { Box, Button, Stack, Typography } from "@mui/material";

function App() {
  return (
    <AuthProvider>
      <SocketProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<LoginView />} />{" "}
            {/* Direct render LoginView */}
            <Route path="/" element={<DashboardWrapper />} />{" "}
            {/* Explicitly render DashboardWrapper for root */}
            {/* Other protected routes can still use ProtectedRoute if needed */}
            {/* Example: <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} /> */}
          </Routes>
        </Router>
      </SocketProvider>
    </AuthProvider>
  );
}

const DashboardWrapper = () => {
  const { socket } = useSocket();
  const { isAuthenticated, loading: authLoading, signOut } = useAuth();
  const dashboardData = useDashboardData(socket);

  if (authLoading) {
    return <FullScreenLoader />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (!socket) {
    return <FullScreenLoader />;
  }

  if (dashboardData.loading) {
    return <FullScreenLoader />;
  }

  if (dashboardData.isDataEmpty) {
    return (
      <Box sx={{ minHeight: "100dvh", display: "grid", placeItems: "center", px: 2 }}>
        <Stack spacing={2} alignItems="center" sx={{ textAlign: "center", maxWidth: 360 }}>
          <img src="/logo.png" alt="Teks" height={28} />
          <Typography sx={{ fontSize: "1.125rem", fontWeight: 650 }}>No data available</Typography>
          <Typography variant="body2" color="text.secondary">
            Your account has no bots assigned yet, or the data feed is still warming up.
          </Typography>
          <Stack direction="row" spacing={1.5}>
            <Button variant="contained" color="secondary" onClick={() => dashboardData.handleDataRefresh()}>
              Refresh
            </Button>
            <Button variant="outlined" color="inherit" onClick={() => signOut()}>
              Sign out
            </Button>
          </Stack>
        </Stack>
      </Box>
    );
  }

  return <Dashboard socket={socket} dashboardData={dashboardData} />;
};

export default App;
